import { ColumnTable } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';

import { TranslationsKeys } from '../../../../locales/translations';

export default function useColumns(
  actionsColumns: ColumnTable[],
): ColumnTable[] {
  const { t } = useTranslation(
    TranslationsKeys.CONFIGURATION_ADDITIONAL_CHARGES,
  );
  return [
    {
      columnName: 'name',
      headerText: t('table.name'),
      tdClassName: 'text-left',
      thClassName: 'text-left',
    },
    {
      columnName: 'period',
      headerText: t('table.period'),
      tdClassName: 'text-left',
      thClassName: 'text-left',
      cellFormat: ({ value }) => value?.name || '-',
    },
    {
      columnName: 'academicLevel',
      headerText: t('table.academicLevel'),
      tdClassName: 'text-left',
      thClassName: 'text-left',
      cellFormat: ({ value }) => value?.name || '-',
    },
    {
      columnName: 'description',
      headerText: t('table.description'),
      tdClassName: 'text-left',
      thClassName: 'text-left',
      cellFormat: ({ value }) => value || '-',
    },
    {
      columnName: 'integrationCode',
      headerText: t('table.integrationCode'),
      tdClassName: 'text-left',
      thClassName: 'text-left',
      cellFormat: ({ value }) => value || '-',
    },
    {
      columnName: 'amount',
      headerText: t('table.amount'),
      tdClassName: 'text-right',
      thClassName: 'text-right',
      cellFormat: ({ value }) =>
        value != null ? Number(value).toLocaleString() : '-',
    },
    ...actionsColumns,
  ];
}
